import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Users, Briefcase } from 'lucide-react';
export function AboutDirector() {
  return <section id="people" className="py-24 bg-[#FAF9F7]" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-25">
          {/* Photo Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-4 flex justify-center lg:justify-end" data-id="element-26">
            <div className="relative" data-id="element-27">
              {/* Decorative background element */}
              <div className="absolute -inset-4 bg-[#800000]/10 rounded-full blur-xl" data-id="element-28"></div>

              {/* Avatar Placeholder */}
              <div className="relative w-64 h-64 md:w-80 md:h-80 bg-[#800000] rounded-full flex items-center justify-center shadow-xl border-4 border-white z-10 overflow-hidden" data-id="element-29">
                <span className="text-6xl md:text-8xl font-serif text-white font-bold tracking-wider" data-id="element-30">
                  AP
                </span>
              </div>

              {/* Floating Badge */}
              <div className="absolute bottom-4 -right-4 bg-white p-4 rounded-xl shadow-lg border border-gray-100 z-20" data-id="element-31">
                <p className="text-sm font-bold text-[#800000]" data-id="element-32">Lab Director</p>
                <p className="text-xs text-gray-500" data-id="element-33">Since 2010</p>
              </div>
            </div>
          </motion.div>

          {/* Bio Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-8" data-id="element-34">
            <h2 className="text-sm font-bold text-[#800000] uppercase tracking-widest mb-2" data-id="element-35">
              Lab Director
            </h2>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 font-serif mb-2" data-id="element-36">
              Dr. Arvind Pattamatta
            </h3>
            <p className="text-lg text-gray-600 font-medium mb-6 pb-6 border-b border-gray-200" data-id="element-37">
              Professor, Department of Mechanical Engineering
            </p>

            <p className="text-gray-600 leading-relaxed mb-8" data-id="element-38">
              Dr. Arvind Pattamatta is a Professor in the Department of
              Mechanical Engineering at IIT Madras. He leads the Multiscale
              Thermal Transport Research Laboratory (MT²RL), where his group
              investigates fluid flow and heat transfer phenomena across
              multiple length scales. His research interests span spray cooling,
              flow boiling, heat pipes, battery thermal management, and
              data-driven thermal design. He has published over 175 research
              papers and has guided 56+ graduate students.
            </p>

            {/* Highlight Chips */}
            <div className="flex flex-wrap gap-4" data-id="element-39">
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-40">
                <BookOpen size={18} className="text-[#800000]" data-id="element-41" />
                <span className="text-sm font-medium text-gray-800" data-id="element-42">
                  175+ Publications
                </span>
              </div>
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-43">
                <Users size={18} className="text-[#800000]" data-id="element-44" />
                <span className="text-sm font-medium text-gray-800" data-id="element-45">
                  56+ Students Guided
                </span>
              </div>
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-46">
                <Briefcase size={18} className="text-[#800000]" data-id="element-47" />
                <span className="text-sm font-medium text-gray-800" data-id="element-48">
                  15 Research Projects
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}